import { asyncThunkCreator, buildCreateSlice, PayloadAction } from '@reduxjs/toolkit';

import { addProductToFavorites } from '@screens/Favorites/api/addProductToFavorites/addProductToFavorites';
import { removeProductFromFavorites } from '@screens/Favorites/api/removeProductFromFavorites/removeProductFromFavorites';
import { FavoritesState } from '@screens/Favorites/model/types/favoritesState';
import { HttpCodes, HttpStatuses } from '@shared/types/enums/http.enum';
import { getCookiesProductsForUser, setCookiesProductsForUser } from '@shared/utils/cookiesUtils/cookiesUtils';
import { openAlert } from '@widgets/AlertModal';

const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator }
});

const initialState: FavoritesState = {
  productIds: []
};

export const favoritesSlice = createAppSlice({
  name: 'favorites',
  initialState,
  reducers: (create) => {
    return {
      updateFavoritesList: create.reducer((state, action: PayloadAction<string[]>) => {
        state.productIds = action.payload;
      }),
      removeFromFavoritesThunk: create.asyncThunk(
        async (id: string, thunkAPI) => {
          const res = await removeProductFromFavorites(id);

          switch (res.code) {
            case HttpCodes.UNAUTHORIZED: {
              const cookiesFavouritesCount = getCookiesProductsForUser<string[]>('favouritesCount');

              const favouritesCount = cookiesFavouritesCount.filter((item) => item !== id);

              setCookiesProductsForUser({
                favouritesCount
              });

              break;
            }
            case HttpCodes.OK: {
              break;
            }
            default: {
              thunkAPI.dispatch(
                openAlert({
                  data: {
                    title: 'Ошибка',
                    text: 'Попробуйте позже'
                  },
                  variant: HttpStatuses.ERROR
                })
              );
              return thunkAPI.rejectWithValue(HttpStatuses.ERROR);
            }
          }

          return {
            id
          };
        },
        {
          fulfilled: (state, action) => {
            state.productIds = state.productIds.filter((el) => el !== action.payload.id);
          }
        }
      ),
      addToFavoriteThunk: create.asyncThunk(
        async (productId: string, thunkAPI) => {
          const res = await addProductToFavorites([productId]);

          switch (res.code) {
            case HttpCodes.UNAUTHORIZED: {
              const cookiesFavouritesCount = getCookiesProductsForUser<string[]>('favouritesCount');

              setCookiesProductsForUser({
                favouritesCount: [...cookiesFavouritesCount, productId]
              });

              break;
            }
            case HttpCodes.CREATED: {
              break;
            }
            default: {
              thunkAPI.dispatch(
                openAlert({
                  data: {
                    title: 'Ошибка',
                    text: 'Попробуйте позже'
                  },
                  variant: HttpStatuses.ERROR
                })
              );
              return thunkAPI.rejectWithValue(HttpStatuses.ERROR);
            }
          }

          return productId;
        },
        {
          fulfilled: (state, action) => {
            state.productIds.push(action.payload);
          }
        }
      )
    };
  }
});

export const { addToFavoriteThunk, removeFromFavoritesThunk, updateFavoritesList } = favoritesSlice.actions;

export const favoritesReducer = favoritesSlice.reducer;
